import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicFieldCheckbox, BaasicButton, BasicInput } from 'core/components';

function BackOrderNewFlowEditModalTemplate({ backOrderNewFlowEditModalViewStore , t}) {
    const {
        form,
        modalParams
    } = backOrderNewFlowEditModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit Backorder</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('backOrder')} /><span className="fake-label">On Backorder</span>
                </div>
                <div className="form__group">
                    <BasicInput field={form.$('backOrderNote')} /> 
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    className='btn btn--med btn--primary'
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Submit"
                />  
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section> 
    )
}
 
BackOrderNewFlowEditModalTemplate.propTypes = {
    backOrderNewFlowEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(BackOrderNewFlowEditModalTemplate);
